import { useContext, useMemo } from "react"
import type { TokenProvider } from "../api/auth/tokenProvider"
import { createCookieTokenProvider, createMsalTokenProvider } from "../api/auth/tokenProvider"
import { createCmApi } from "../api/cmApi/createCmApi"
import type { ICmApi } from "../api/cmApi/types"
import { createHttpClient } from "../api/http/httpClient"
import { AUTH_METHOD } from "../constants/authMethods"
import { AuthContext } from "../context/auth/AuthProvider"
import { useSessionRecovery } from "../context/auth/SessionRecoveryProvider"

export function useCmApi(): ICmApi {
  const auth = useContext(AuthContext)
  const { requestSessionRecovery } = useSessionRecovery()

  if (!auth) {
    throw new Error("useCmApi must be used within AuthProvider")
  }

  const provider = useMemo<TokenProvider>(() => {
    if (auth.type === AUTH_METHOD.MSAL) {
      return createMsalTokenProvider({ acquireTokenSilent: auth.acquireTokenSilent }, auth.accounts[0], auth.scopes)
    }

    return createCookieTokenProvider()
  }, [auth])

  const sessionRecovery = auth.type === AUTH_METHOD.MSAL ? requestSessionRecovery : undefined

  return useMemo(() => createCmApi(createHttpClient(provider, sessionRecovery)), [provider, sessionRecovery])
}
